import { NoAccessToIncidentWorkflowsError } from 'src/lib/error';
import { decodeHtml } from 'src/lib/htmlDecoder';

export const handlePagerDutyApiResponse = ({ headers, url, status, responseText }) => {
  let responseJSON = null;
  try {
    responseJSON = JSON.parse(responseText);
  } catch (e) {
  }

  if ((String(status))[0] === '2') return responseJSON;

  if (status === 404 && url.includes('/jira_server_views/sidebar_info')) {
    throw new Error('Can not find linked PagerDuty account');
  }

  if (status === 403 && url.includes('/incident_workflows/triggers')) {
    if (responseJSON?.message?.includes('does not have access to incident_workflows')) {
      throw new NoAccessToIncidentWorkflowsError();
    }
  }

  responseText = responseText.trim();
  const responseTitle = responseText.match(/<title>(.*?)<\/title>/);
  if (responseTitle && responseTitle[1]) {
    throw new Error(decodeHtml(responseTitle[1]));
  }

  const responseH2 = responseText.match(/<h2>(.*?)<\/h2>/);
  if (responseH2 && responseH2[1]) {
    throw new Error(decodeHtml(responseH2[1]));
  }

  if ((status === 404 || status === 401) && responseText && !responseJSON) {
    if (headers.Authorization.startsWith('Bearer ')) {
      if (!responseText.includes('</html>') && responseText.length < 300) {
        // it's likely raw message with error
        throw new Error(responseText);
      }
      throw new Error('Unknown error. It might be caused by expired or revoked session, please log out');
    } else {
      throw new Error('PagerDuty Authorization failed');
    }
  }

  const message = responseJSON?.error?.message || responseJSON?.message;
  const errors = responseJSON?.error?.errors;
  const error = (responseJSON && typeof responseJSON.error === 'string' && responseJSON.error);

  if (!message && !errors && !error) {
    throw new Error(`PagerDuty request failed. status = ${status}`);
  }

  if (error) {
    throw new Error(error);
  }

  if (!errors) {
    throw new Error(message);
  }

  if (errors.length === 1 && errors[0] === message) {
    throw new Error(message);
  }

  throw new Error(`${message}. ${errors.join('. ')}`);
};
